export var actionKey = '@@tierConsumer';
export var tierConsumerReduxKey = '@@tierConsumer';
//# sourceMappingURL=constants.js.map